import $ from 'jquery';
import Swiper from 'swiper';
// import Flickity from 'flickity';
import lax from 'lax.js';
import {jarallax} from 'jarallax';
import AOS from 'aos';
import inlineSVG from 'inline-svg';
import WebFont from 'webfontloader';
import Dotdotdot from 'dotdotdot-js';
import _ from 'lodash';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import moment from 'moment';
// import isotope from 'isotope-layout';
import { detect } from 'detect-browser';
import Fancybox from '@fancyapps/ui/dist/fancybox.umd';
import anime from 'animejs';

/**
 * Header State
 */
let siteHeader = document.querySelector('.site-header');
let hasAdminbar = document.body.classList.contains('admin-bar');

if (hasAdminbar) {
  let mq = matchMedia('(max-width:600px)');
  window.addEventListener('scroll', _.throttle(() => headerState(mq), 16));
  mq.addEventListener('change', () => headerState(mq));
  if ('complete' !== document.readyState) {
    document.addEventListener('DOMContentLoaded', headerState(mq));
  } else {
    headerState(mq);
  }
}

function headerState(mq) {
  if (mq.matches && scrollY <= 46) {
    siteHeader.classList.add('stick-with-adminbar');
  } else {
    siteHeader.classList.remove('stick-with-adminbar');
  }
}

/**
 * Global Fancybox init
 */
Fancybox.bind('[data-fancybox]', {
  Toolbar: {
    display: ['zoom', 'fullscreen', 'close']
  }
});

let blockHero = [...document.querySelectorAll('.block-hero')];
blockHero.forEach(block => {
  let swiperEl = block.querySelector('.block-hero-carousel');
  new Swiper(swiperEl, {
    preloadImages: false,
    lazy: true,
  });
});

let origY = 0;
let offset = 60;
let offsetDown = 0;
let offsetUp = 0;

function handleScrollDirection(downcb, upcb) {
  let y = window.scrollY;
  let dir = y > origY ? 'DOWN' : 'UP';

  if ( 'DOWN' === dir ) {
    if ( y > offsetDown ) {
      downcb();
      offsetUp = y-offset;
    }
  } else if ( 'UP' === dir ) {
    if ( y < offsetUp ) {
      upcb();
      offsetDown = y+offset;
    }
  }
  
  origY = y;
}

window.addEventListener('scroll', _.throttle(function() {
  let $floatBookButton = document.querySelector('#float_book_button');
  handleScrollDirection(
    () => {
      $floatBookButton.classList.remove('scroll-up');
      $floatBookButton.classList.add('scroll-down');
    },
    () => {
      $floatBookButton.classList.remove('scroll-down');
      $floatBookButton.classList.add('scroll-up');
    }
  )
}, 16));

// new Swiper('.swiper-rooms', {
//   speed: 1500,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true,
//   }
// })

const GlobalFnPrefix = 'OM';

/**
 * AddGlobalFn
 * 
 * @param {string} key Method name
 * @param {string} val function
 * 
 * @return Boolean;
 */
const AddGlobalFn = (key, val) => {
  if (!HasGlobalFn(key)) {
    window[GlobalFnPrefix][key] = val;
    return true;
  }

  console.error(`This '${key}' has already registerd`);
  return false;
}

/**
 * HasGlobalFn
 * 
 * @param {string} key Method name that want to check
 * 
 * @return Boolean
 */
const HasGlobalFn = key => {
  return window[GlobalFnPrefix].hasOwnProperty(key);
}

if ('undefined' !== typeof window.OM) {
  throw `${GlobalFnPrefix} has already registered.`;
} else {
  window[GlobalFnPrefix] = {};
}

AddGlobalFn('_addGlobalFn', AddGlobalFn);
AddGlobalFn('_hasGlobalFn', HasGlobalFn);

/**
 * Document state by className
 */
var docContentReady = ev => {
  document.documentElement.classList.add('is-ready');
}

var docContentLoaded = ev => {
  document.documentElement.classList.add('is-loaded');
}

var docResizeend = _.debounce(ev => {
  document.documentElement.classList.remove('is-resizing');
  window.removeEventListener('resize', docResizeend);
}, 150);

var docResizing = _.throttle(ev => {
  if (!document.documentElement.classList.contains('is-resizing')) {
    document.documentElement.classList.add('is-resizing');
    window.addEventListener('resize', docResizeend);
  }
}, 16);

document.addEventListener('DOMContentLoaded', docContentReady);
window.addEventListener('loaded', docContentLoaded);
window.addEventListener('resize', docResizing);

/**
 * Jarallax
 */
$('.jarallax').each((i, el) => {
  var position = {
    x: $(el).data('positionX') || '50%',
    y: $(el).data('positionY') || '50%',
  }

  jarallax( el, {
    imgPosition: position.x + '%' + ' ' + position.y + '%',
  } );
});

/** 
 * FancyBox
 */
// $('[data-fancybox="preview"], [data-fancybox="content"]').fancybox({
//   loop: true,
//   thumbs : {
//     autoStart : true
//   }
// });

let swiperMouse = new Swiper('.hero-horizontal', {
  // freeMode: true,
  parallax: true,
  slidesPerView: 1,
  watchSlidesProgress: true,
  mousewheel: {
    forceToAxis: true,
  },

  // freeMode: true,
  // speed: 3000,
  // simulateTouch: false,
  // slidesPerView: 1,
  // mousewheel: true,
  // preloadImages: false,
  // parallax: true,
  // lazy: true,
});

// swiperMouse.el.addEventListener('wheel', ev => {
//   swiperMouse.el.scrollBy({
//     left: ev.wheelDeltaY * -1,
//   })
// })

swiperMouse.on('scroll', function (i,e) {
  var index  = i.activeIndex;
  var scroll = i.previousTranslate;
  var $bg = $('.side-panel__bg');
  var $logo = $('.site-logo');

  if(scroll < 0) {
      $bg.addClass('side-show');
      $logo.addClass('pull-up');
  } else {
      $bg.removeClass('side-show');
      $logo.removeClass('pull-up');
  }

  var $btnBook = $('.button-book-fixed .button');
  switch (index) {
      case 0 :
          $btnBook.addClass('is-dark').removeClass('is-light');
          break;
      case 1 :
          $btnBook.addClass('is-dark').removeClass('is-light');
          break;
      case 2 :
          $btnBook.addClass('is-light').removeClass('is-dark');
          break;
      case 3 :
          $btnBook.addClass('is-dark').removeClass('is-light');
          break;
      case 4 :
          $btnBook.addClass('is-dark').removeClass('is-light');
          break;
      default :
          $btnBook.addClass('is-light').removeClass('is-dark');
  }
    
});

/**
 * Position Image
 */
$('.img-cover').each((i, el) => {
  var position = {
    x: $(el).data('positionX') || '50%',
    y: $(el).data('positionY') || '50%',
  }

  $(el).css('object-position', position.x + '%' + ' ' + position.y + '%');
});

/**
 * Animate on scroll
 */
AOS.init({
  once: true,
  duration: 1000,
});

/**
 * Webfontloader
 */
 WebFont.load({
  google: {
    families: ['Roboto Condensed:300,400,700']
  },
  custom: {
    families: [
      'Agrandir Grand',
      'Montserrat',
    ],
    urls: [
      Passa.wp.themeurl + '/assets/fonts/agrandir/stylesheet.css',
      Passa.wp.themeurl + '/assets/fonts/montserrat/stylesheet.css',
      // Passa.wp.themeurl + '/assets/fonts/gotham/stylesheet.css',
      // Passa.wp.themeurl + '/assets/fonts/newbaskerville/stylesheet.css',
    ]
  }
});

/**
 * Convert svg image to inline svg
 */
inlineSVG.init({
  svgSelector: 'img.svg',
});

/**
 * Lax setup
 */
window.addEventListener('load', ev => {
  lax.setup();
  const updateLax = () => {
    lax.update(window.scrollY);
    window.requestAnimationFrame(updateLax);
  }
  window.requestAnimationFrame(updateLax);
});

/**
 * BookingPanel methods
 */
const BookingPanel = {
  data: {
    panel: '.lm-booking-panel__inner',
    panelBg: '.lm-booking-panel__bg',
    panelWrap: '.lm-booking-panel',
    panelAnimateEasing: 'easeOutExpo',
    panelAnimateDuration: 500,
    toggleBodyClass: 'lm-booking-panel-show',
    toggleButtons: '.lm-booking-panel-toggle-button',
    toggleButtonsActiveClass: 'active',
  },

  show() {
    $('body').addClass(this.data.toggleBodyClass);
    $(this.data.toggleButtons).addClass(this.data.toggleButtonsActiveClass);
    $(this.data.panelBg).on('wheel.panelBg', ev => this.hide());
  },
  
  hide() {
    $('body').removeClass(this.data.toggleBodyClass);
    $(this.data.toggleButtons).removeClass(this.data.toggleButtonsActiveClass);
    $(this.data.panelBg).off('wheel.panelBg');
  },

  toggle() {
    this.isShow() ? this.hide() : this.show();
  },

  isShow() {
    return $('body').hasClass(this.data.toggleBodyClass);
  },

  init() {
    AddGlobalFn('BookingPanel', this);
  }
}

BookingPanel.init();

/**
 * SidePanel methods
 */
const SidePanel = {
  data: {
    panel: '.side-panel__inner',
    panelBg: '.side-panel__bg',
    panelWrap: '.side-panel',
    panelLogo: '.side-panel__logo',
    toggleBodyClass: 'side-panel-show',
    toggleButtons: '.side-panel-toggle-button',
    toggleButtonsActiveClass: 'active',
  },

  _getDuration() {
    let el = document.querySelector(this.data.panel);
    let val = getComputedStyle(el).getPropertyValue('transition-duration');
    let unit = val.indexOf('ms') > -1 ? 'MILLISECONDS' : 'SECONDS';
    let num = parseFloat(val);
    return ('MILLISECONDS' === unit) ? num : num*1000;
  },

  show() {
    let panelEl = document.querySelector(this.data.panelWrap);
    let panelInnerEl = panelEl.querySelector(this.data.panel);
    let menuItems = [...panelInnerEl.querySelectorAll('.menu-item > a')];
    let panelLogo = panelEl.querySelector(this.data.panelLogo);

    document.body.classList.add(this.data.toggleBodyClass);
    $(this.data.toggleButtons).addClass(this.data.toggleButtonsActiveClass);
    $('#header_menu_button').addClass('show');
    $(this.data.panelBg).on('wheel.panelBg', ev => this.hide());

    panelEl.classList.add('ready');
    setTimeout(() => {
      panelEl.classList.add('shown');
    }, this._getDuration());

    // menuItemAnimated
    anime({
      targets: menuItems,
      translateY: ['5rem', 0],
      duration: 1000,
      easing: 'easeOutQuint',
      delay: (el, i) => {
        return i * 32 + (this._getDuration() - 100);
      },
    });

    // logoAnimated
    anime({
      targets: panelLogo,
      translateY: ['-500%', 0],
      delay: this._getDuration() - 200,
      duration: 1000,
      easing: 'easeOutQuint',
    });
  },
  
  hide() {
    let panelEl = document.querySelector(this.data.panelWrap);

    document.body.classList.remove(this.data.toggleBodyClass);
    $(this.data.toggleButtons).removeClass(this.data.toggleButtonsActiveClass);
    $(this.data.panelBg).off('wheel.panelBg');
    $('#header_menu_button').removeClass('show');

    panelEl.classList.add('hiding');
    setTimeout(() => {
      panelEl.classList.remove('hiding');
      panelEl.classList.remove('shown');
      panelEl.classList.remove('ready');
    }, this._getDuration());
  },

  toggle() {
    this.isShow() ? this.hide() : this.show();
  },

  isShow() {
    return $('body').hasClass(this.data.toggleBodyClass);
  },

  init() {
    AddGlobalFn('SidePanel', this);
  }
}

SidePanel.init();

/**
 * Exclusive Panel
 */
// const ExclusivePanel = {
//   data: {
//     panel: '.om-exclusive-panel__inner',
//     panelBg: '.om-exclusive-panel__bg',
//     panelWrap: '.om-exclusive-panel',
//     toggleBodyClass: 'om-exclusive-panel-show',
//     toggleButtons: '.exclusive-panel-toggle-button',
//     toggleButtonsActiveClass: 'active',
//   },

//   show() {
//     $('body').addClass(this.data.toggleBodyClass);
//     $(this.data.toggleButtons).addClass(this.data.toggleButtonsActiveClass);
//   },
  
//   hide() {
//     $('body').removeClass(this.data.toggleBodyClass);
//     $(this.data.toggleButtons).removeClass(this.data.toggleButtonsActiveClass);
//   },

//   toggle() {
//     this.isShow()
//       ? this.hide()
//       : this.show()
//   },

//   isShow() {
//     return $(this.data.panelWrap).hasClass(this.data.toggleBodyClass);
//   },

//   init() {
//     AddGlobalFn('ExclusivePanel', this);
//   }
// }

// ExclusivePanel.init();

var slidePan = function( slide ) {
  let current = slide.slides[slide.activeIndex];
  let previous = slide.slides[slide.previousIndex];
  let speed = slide.params.speed;
  let duration = slide.params.autoplay.delay;

  current.classList.add('slide-animate');
  let currentImg = current.querySelector('img');
  currentImg.style.animationDuration = speed * 2 + duration + 'ms';

  if (previous) {
    setTimeout(() => {
      previous.classList.remove('slide-animate');
    }, speed);
  }
}

new Swiper('.om-hero .swiper-container', {
  loop: false,
  loopedSlides: 0,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    stopOnLastSlide: false,
  },
  allowTouchMove: false,
  speed: 2000,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: '.om-hero-pagination',
    clickable: true,
  },
  on: {
    init: slidePan,
    slideChange: slidePan,
  }
});

// var headerEffect = ( customTrigger ) => {
//   var headerToggleClass = () => {
//     var y = window.scrollY || window.pageYOffset;
//     var trigger = 0;
  
//     if ('string' === typeof customTrigger && document.querySelector(customTrigger)) {
//       var target = document.querySelector(customTrigger);
//       trigger = target.clientTop + target.clientHeight;
//     } else if ('number' === typeof customTrigger) {
//       trigger = customTrigger;
//     }
//     document.querySelector('.site-header').classList.toggle('show', y >= trigger);
//     document.querySelector('body').classList.toggle('header-shown', y >= trigger);
//   }

//   headerToggleClass();
//   window.addEventListener('scroll', _.throttle(headerToggleClass, 16));
// }

// AddGlobalFn('HeaderFX', headerEffect);

/**
 * Change logo color by className with scroll trigger function
 */
gsap.registerPlugin(ScrollTrigger);

class ScrollToggleColor {
  constructor(selector, opts) {
    this.el = document.querySelector(selector);
    this.colorSet = opts.colorSet;
    this.offset = opts.offset || 0;
  }

  init() {
    if (!this.el) {
      return;
    }

    var endEl = document.createElement('div');
    endEl.id = '_END';
    endEl.setAttribute('aria-hidden', true);
    if (!document.getElementById('_END')) {
      body.append(endEl);
    }

    var sortedColorSet = this.colorSet.sort((a, b) => {
      let elA = document.querySelector(a.selector) ? document.querySelector(a.selector).offsetTop : 999999;
      let elB = document.querySelector(b.selector) ? document.querySelector(b.selector).offsetTop : 999999;
      return elA - elB;
    });

    for (let i = 0; i < sortedColorSet.length; i++) {
      let selector = sortedColorSet[i].selector;
      let nextSelector = sortedColorSet[i+1] ? sortedColorSet[i+1].selector : '#_END';
      let color = sortedColorSet[i].color;
      let className = sortedColorSet[i].className;
      let enterEvent = () => {
        if (color) {
          this.el.style.color = color;
        }

        if (className) {
          this.el.classList.add(className)
        }
      }
      let leaveEvent = () => {
        if (color) {
          this.el.style.color = ''
        }

        if (className) {
          this.el.classList.remove(className);

        }
      }

      ScrollTrigger.create({
        trigger: selector,
        start: `top top+=${this.offset}`,
        endTrigger: nextSelector,
        end: `top top+=${this.offset}`,
        onEnter: enterEvent,
        onEnterBack: enterEvent,
        onLeave: leaveEvent,
        onLeaveBack: leaveEvent,
      });
    }
  }
}

AddGlobalFn('ScrollToggleColor', ScrollToggleColor);

/**
 * Register Color Set
 * @param {array} set Set of selector and className
 */
var registerLogoColorSet = ( set ) => {
  set.forEach(item => {
    window[GlobalFnPrefix].logoColorSet.push(item);
  });

  logoColorSetInit();
  window.addEventListener('DOMContentLoaded', logoColorSetInit);
  window.addEventListener('load', logoColorSetInit);
}

AddGlobalFn('logoColorSet', []);
AddGlobalFn('RegisterLogoColorSet', registerLogoColorSet);

// var homeRoomSlider = document.querySelector('#home_rooms .slider');

// if (homeRoomSlider) {
//   var images = homeRoomSlider.querySelectorAll('img');
//   new Flickity (homeRoomSlider, {
//     cellAlign: 'center',
//     prevNextButtons: true,
//     pageDots: true,
//     autoPlay: true,
//     pauseAutoPlayOnHover: false,
//     on: {
//       scroll() {
//         this.slides.forEach( (slide, i) => {
//           let x = (slide.target + this.x) * -1/5;
//           let img = images[i];
//           img.style.transform = `translate3d(${x}px, 0, 250px)`;
//         } );
//       },
//     }
//   });
// }

// var homeLocateSlider = document.querySelector('#home_locate .slider');

// if (homeLocateSlider) {
//   var homeLocate = new Swiper('#home_locate .slider', {
//     slidesPerView: 'auto',
//     spaceBetween: 15,
//     slidesOffsetBefore: 30,
//     slidesOffsetAfter: 30,
//     freeMode: true,
//     speed: 1000,
//     autoplay: {
//       delay: 1500,
//     },
//     // scrollbar: {
//     //   el: '.swiper-scrollbar',
//     //   hide: true,
//     // },
//     // pagination: {
//     //   el: '.slider-pagination',
//     //   type: 'bullets',
//     //   bulletClass: 'slider-pagination-bar',
//     //   bulletActiveClass: 'slider-pagination-bar--active',
//     //   renderBullet: function (index, className) {
//     //     return `<span class="${className}"></span>`;
//     //   }
//     // },
//     pagination: {
//       el: '.slider-pagination-fraction',
//       type: 'fraction',
//       renderFraction: function (currentClass, totalClass) {
//         return  '<span class="' + currentClass + '"></span>' +
//                 '<span class="px-1"> / </span>' +
//                 '<span class="' + totalClass + '"></span>';
//       }
//     },
//     navigation: {
//       prevEl: '.swiper-offers-button-prev',
//       nextEl: '.swiper-offers-button-next',
//     },
//     // breakpoints: {
//     //   768: {
//     //     slidesOffsetBefore: 15,
//     //     slidesOffsetAfter: 15,
//     //   }
//     // }
//   });

//   var winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//   if(winW >= 768) {
//     homeLocate.autoplay.stop();
//   }
// }

// var homeOffersSlider = document.querySelector('#home_offers .slider');

// if (homeOffersSlider) {
//   var homeOffers = new Swiper('#home_offers .slider', {
//     slidesPerView: 'auto',
//     spaceBetween: 15,
//     slidesOffsetBefore: 30,
//     slidesOffsetAfter: 30,
//     freeMode: true,
//     speed: 1000,
//     autoplay: {
//       delay: 1500,
//     },
//     scrollbar: {
//       el: '.swiper-scrollbar',
//       hide: true,
//     },
//     pagination: {
//       el: '.slider-pagination',
//       type: 'bullets',
//       bulletClass: 'slider-pagination-bar',
//       bulletActiveClass: 'slider-pagination-bar--active',
//       renderBullet: function (index, className) {
//         return `<span class="${className}"></span>`;
//       }
//     },
//     navigation: {
//       prevEl: '.swiper-button-prev',
//       nextEl: '.swiper-button-next',
//     },
//     breakpoints: {
//       768: {
//         slidesOffsetBefore: 15,
//         slidesOffsetAfter: 15,
//       }
//     }
//   });

//   var winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//   if(winW >= 768) {
//     homeOffers.autoplay.stop();
//   }

//   var $OffersSlider = $('.swiper-offers-slide');
//   if($OffersSlider.length <= 3) {
//     $('.swiper-offers-button-prev').addClass('d-none');
//     $('.swiper-offers-button-next').addClass('d-none');
//     $('.slider-pagination').addClass('d-none');
//   } else {
//     $('.swiper-offers-button-prev').removeClass('d-none');
//     $('.swiper-offers-button-next').removeClass('d-none');
//     $('.slider-pagination').removeClass('d-none');
//   }
// }

// var showElements = Array.prototype.slice.call(document.querySelectorAll('.show-on-hover'));
// showElements.forEach(el => {
//   let parent = el.querySelector('.content__description');
//   let children = Array.prototype.slice.call(parent.children);
//   let show = 0;
  
//   el.addEventListener('mouseenter', ev => {
//     let height = 0 + 16;

//     children.forEach(child => {
//       let h = child.clientHeight;
//       let s = window.getComputedStyle(child);
//       let m = parseFloat(s.marginTop + s.marginBottom);
//       height += h + m;
//     });

//     parent.style.height = `${height}px`;
//     show = 1;
//   });

//   el.addEventListener('mouseleave', ev => {
//     parent.style.height = '0px';
//     show = 0;
//   });

//   parent.addEventListener('transitionend', ev => {
//     if (!show) {
//       parent.style.height = '';
//     }
//   })
// });

/**
 * Dropdown Component
 */
var omDropdowns = document.querySelectorAll('.lm-dropdown');
omDropdowns = Array.prototype.slice.call(omDropdowns);

if (omDropdowns) {
  for(let i = 0; i < omDropdowns.length; i++) {
    let wrap = omDropdowns[i];
    let menu = wrap.querySelector('.lm-dropdown-menu');
    let toggle = wrap.querySelector('.lm-dropdown-toggle');

    var isShow = () => wrap.classList.contains('show') || menu.classList.contains('show');
    var outsideClose = event => {
      let target = event.target;
      if (!wrap.contains(target)) {
        wrap.classList.remove('show');
        menu.classList.remove('show');
      }
    }
    var toggleMenu = () => {
      if (!isShow()) {
        reposition();
        wrap.classList.add('show');
        menu.classList.add('show');
        document.addEventListener('click', outsideClose);
      } else {
        wrap.classList.remove('show');
        menu.classList.remove('show');
        document.removeEventListener('click', outsideClose);
      }
    }

    toggle.addEventListener('click', toggleMenu);

    var reposition = () => {
      let win = window.innerWidth;
      let scrollbar = win - document.documentElement.clientWidth;
      let cord = {
        menu: menu.getBoundingClientRect(),
        wrap: wrap.getBoundingClientRect(),
      }
      let menuRight = cord.menu.width + cord.wrap.left + scrollbar;

      if (win < menuRight) {
        let diff = Math.round(win - menuRight);
        menu.style.marginLeft = diff+'px';
      } else {
        menu.style.marginLeft = '';
      }
    }

    window.addEventListener('load', reposition);
    window.addEventListener('resize', _.debounce(reposition, 150));
  }
}

/**
 * Dotdotdot Global
 */
var DotsInit = el => {
  var lh = parseFloat( window.getComputedStyle(dotEl).getPropertyValue('line-height') );
  var lines = dotEl.dataset.dotsLines || 2;
  new Dotdotdot(el, {
    height: lh * lines,
  });
}

var globalDots = document.querySelectorAll('[data-dots]');
var globalDots = Array.prototype.slice.call(globalDots);

for (let i = 0; i < globalDots.length; i++) {
  var dotEl = globalDots[i];
  DotsInit(dotEl);
}

AddGlobalFn('Dots', DotsInit);

var body = document.querySelector('body');
// var toggleQuickMenu = () => {
//   body.classList.toggle('bottom-bar-show', window.scrollY > 40);
// }

// window.addEventListener('load', toggleQuickMenu);
// window.addEventListener('scroll', _.throttle(toggleQuickMenu, 16));

$(window).on('scroll resize', function(){
  var $body = $('body');
  var winY = window.scrollY || window.pageYOffset;
  // var winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if(winY >= 100){
    $body.addClass('header-shown');
  } else {
    $body.removeClass('header-shown');
  }
});

/** 
 * Booking Form 
 */
var bookForm  = $('#form_booking');
// var bookBar   = $('#booking_form');

var nextDay = bookForm.find('[name="nextday"]').val();
// var nextDay = bookForm.find('[name="nextday"]').val() || bookBar.find('[name="nextday"]').val();

var now    = moment().tz('Asia/Bangkok');
var twoday = moment().add(nextDay,'d');
var holidays = {
  '2018-12-31' : 'Happy New Years',
  '2019-02-14' : 'Valentine\'s Day ',
};
var disabledate = [
  '2020-08-12',
  '2020-08-19',
];

var langPicker = document.documentElement.lang;
var langPage   = langPicker.slice(0, 2);

var dayCI = moment(now).format('ddd');
var dayCO = moment(twoday).format('ddd');

switch (langPage) {
  case 'en':
    var titledays   = ['MO','TU','WE','TH','FR','SA','SU'];
    var titlemonths = ['January','February','March','April','May','June','July','August','September','October','November','December']; 
    var titledate   = 'night';
    var titledates  = 'nights';
    var titletoday  = 'Today';
    break;
  case 'zh':
    var titledays   = ['周一','周二','周三','周四','周五','周六','周日'];
    var titlemonths = ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月']; 
    var titledate   = '晚上';
    var titledates  = '晚上';
    var titletoday  = '今天';
    switch (dayCI) {
      case 'Mon': var dayCI = '周一'; break;
      case 'Tue': var dayCI = '周二'; break;
      case 'Wed': var dayCI = '周三'; break;
      case 'Thu': var dayCI = '周四'; break;
      case 'Fri': var dayCI = '周五'; break;
      case 'Sat': var dayCI = '周六'; break;
      case 'Sun': var dayCI = '周日'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = '周一'; break;
      case 'Tue': var dayCO = '周二'; break;
      case 'Wed': var dayCO = '周三'; break;
      case 'Thu': var dayCO = '周四'; break;
      case 'Fri': var dayCO = '周五'; break;
      case 'Sat': var dayCO = '周六'; break;
      case 'Sun': var dayCO = '周日'; break;
    }
    break;
  case 'it':
    var titledays   = ['lu','ma','me','gi','ve','sa','do'];
    var titlemonths = ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre']; 
    var titledate   = 'notti';
    var titledates  = 'notti';
    var titletoday  = 'Oggi';
    switch (dayCI) {
      case 'Mon': var dayCI = 'lu'; break;
      case 'Tue': var dayCI = 'ma'; break;
      case 'Wed': var dayCI = 'me'; break;
      case 'Thu': var dayCI = 'gi'; break;
      case 'Fri': var dayCI = 've'; break;
      case 'Sat': var dayCI = 'sa'; break;
      case 'Sun': var dayCI = 'do'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = 'lu'; break;
      case 'Tue': var dayCO = 'ma'; break;
      case 'Wed': var dayCO = 'me'; break;
      case 'Thu': var dayCO = 'gi'; break;
      case 'Fri': var dayCO = 've'; break;
      case 'Sat': var dayCO = 'sa'; break;
      case 'Sun': var dayCO = 'do'; break;
    }
    break;
  case 'ru':
    var titledays   = ['пн','вт','ср','чт','пт','сб','вс'];
    var titlemonths = ['январь','февраль','март','апрель','май','июнь','июль','август','сентябрь','октябрь','ноябрь','декабрь']; 
    var titledate   = 'ночи';
    var titledates  = 'ночи';
    var titletoday  = 'Сегодня';
    switch (dayCI) {
      case 'Mon': var dayCI = 'пн'; break;
      case 'Tue': var dayCI = 'вт'; break;
      case 'Wed': var dayCI = 'ср'; break;
      case 'Thu': var dayCI = 'чт'; break;
      case 'Fri': var dayCI = 'пт'; break;
      case 'Sat': var dayCI = 'сб'; break;
      case 'Sun': var dayCI = 'вс'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = 'пн'; break;
      case 'Tue': var dayCO = 'вт'; break;
      case 'Wed': var dayCO = 'ср'; break;
      case 'Thu': var dayCO = 'чт'; break;
      case 'Fri': var dayCO = 'пт'; break;
      case 'Sat': var dayCO = 'сб'; break;
      case 'Sun': var dayCO = 'вс'; break;
    }
    break;
  case 'es':
    var titledays   = ['lu','ma','mi','ju','vi','sá','do'];
    var titlemonths = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']; 
    var titledate   = 'noches';
    var titledates  = 'noches';
    var titletoday  = 'Hoy';
    switch (dayCI) {
      case 'Mon': var dayCI = 'lu'; break;
      case 'Tue': var dayCI = 'ma'; break;
      case 'Wed': var dayCI = 'mi'; break;
      case 'Thu': var dayCI = 'ju'; break;
      case 'Fri': var dayCI = 'vi'; break;
      case 'Sat': var dayCI = 'sá'; break;
      case 'Sun': var dayCI = 'do'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = 'lu'; break;
      case 'Tue': var dayCO = 'ma'; break;
      case 'Wed': var dayCO = 'mi'; break;
      case 'Thu': var dayCO = 'ju'; break;
      case 'Fri': var dayCO = 'vi'; break;
      case 'Sat': var dayCO = 'sá'; break;
      case 'Sun': var dayCO = 'do'; break;
    }
    break;
  case 'fr':
    var titledays   = ['lu','ma','me','je','ve','sa','di'];
    var titlemonths = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre']; 
    var titledate   = 'nuits';
    var titledates  = 'nuits';
    var titletoday  = 'Aujourd\'hui';
    switch (dayCI) {
      case 'Mon': var dayCI = 'lu'; break;
      case 'Tue': var dayCI = 'ma'; break;
      case 'Wed': var dayCI = 'me'; break;
      case 'Thu': var dayCI = 'je'; break;
      case 'Fri': var dayCI = 've'; break;
      case 'Sat': var dayCI = 'sa'; break;
      case 'Sun': var dayCI = 'di'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = 'lu'; break;
      case 'Tue': var dayCO = 'ma'; break;
      case 'Wed': var dayCO = 'me'; break;
      case 'Thu': var dayCO = 'je'; break;
      case 'Fri': var dayCO = 've'; break;
      case 'Sat': var dayCO = 'sa'; break;
      case 'Sun': var dayCO = 'di'; break;
    }
    break;
  case 'de':
    var titledays   = ['Mo','Di','Mi','Do','Fr','Sa','So'];
    var titlemonths = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember']; 
    var titledate   = 'Nächte';
    var titledates  = 'Nächte';
    var titletoday  = 'Heute';
    switch (dayCI) {
      case 'Mon': var dayCI = 'Mo'; break;
      case 'Tue': var dayCI = 'Di'; break;
      case 'Wed': var dayCI = 'Mi'; break;
      case 'Thu': var dayCI = 'Do'; break;
      case 'Fri': var dayCI = 'Fr'; break;
      case 'Sat': var dayCI = 'Sa'; break;
      case 'Sun': var dayCI = 'So'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = 'Mo'; break;
      case 'Tue': var dayCO = 'Di'; break;
      case 'Wed': var dayCO = 'Mi'; break;
      case 'Thu': var dayCO = 'Do'; break;
      case 'Fri': var dayCO = 'Fr'; break;
      case 'Sat': var dayCO = 'Sa'; break;
      case 'Sun': var dayCO = 'So'; break;
    }
    break;
  case 'kr':
    var titledays   = ['월','화','수','목','금','토','일'];
    var titlemonths = ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월']; 
    var titledate   = '밤';
    var titledates  = '밤';
    var titletoday  = '오늘';
    switch (dayCI) {
      case 'Mon': var dayCI = '월'; break;
      case 'Tue': var dayCI = '화'; break;
      case 'Wed': var dayCI = '수'; break;
      case 'Thu': var dayCI = '목'; break;
      case 'Fri': var dayCI = '금'; break;
      case 'Sat': var dayCI = '토'; break;
      case 'Sun': var dayCI = '일'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = '월'; break;
      case 'Tue': var dayCO = '화'; break;
      case 'Wed': var dayCO = '수'; break;
      case 'Thu': var dayCO = '목'; break;
      case 'Fri': var dayCO = '금'; break;
      case 'Sat': var dayCO = '토'; break;
      case 'Sun': var dayCO = '일'; break;
    }
    break;
  case 'jp':
    var titledays   = ['月','火','水','木','金','土','日'];
    var titlemonths = ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']; 
    var titledate   = '夜';
    var titledates  = '夜';
    var titletoday  = '今日';
    switch (dayCI) {
      case 'Mon': var dayCI = '月'; break;
      case 'Tue': var dayCI = '火'; break;
      case 'Wed': var dayCI = '水'; break;
      case 'Thu': var dayCI = '木'; break;
      case 'Fri': var dayCI = '金'; break;
      case 'Sat': var dayCI = '土'; break;
      case 'Sun': var dayCI = '日'; break;
    }
    switch (dayCO) {
      case 'Mon': var dayCO = '月'; break;
      case 'Tue': var dayCO = '火'; break;
      case 'Wed': var dayCO = '水'; break;
      case 'Thu': var dayCO = '木'; break;
      case 'Fri': var dayCO = '金'; break;
      case 'Sat': var dayCO = '土'; break;
      case 'Sun': var dayCO = '日'; break;
    }
    break;
  default:
    var titledays   = ['MO','TU','WE','TH','FR','SA','SU'];
    var titlemonths = ['January','February','March','April','May','June','July','August','September','October','November','December']; 
    var titledate   = 'night';
    var titledates  = 'nights';
    var titletoday  = 'Today';
}

$(window).on('load', function(){
  var noCI = moment(now).format('DD');
  var noCO = moment(twoday).format('DD');

  bookForm.find('.t-day-checkin').text(dayCI);
  bookForm.find('.t-day-checkout').text(dayCO);
  bookForm.find('.t-checkin-number').text(noCI);
  bookForm.find('.t-checkout-number').text(noCO);

  // bookBar.find('.t-day-checkin').text(dayCI);
  // bookBar.find('.t-day-checkout').text(dayCO);
  // bookBar.find('.t-checkin-number').text(noCI);
  // bookBar.find('.t-checkout-number').text(noCO);

  var timeStamp = (twoday - now) / 86400;
  var rangeDate = (timeStamp / 1000);
  var mathRange = Math.round(rangeDate);
  
  if(mathRange > 1) {
    var rangeDays = mathRange+' '+titledates;
  }
  if(mathRange == 1) {
    var rangeDays = mathRange+' '+titledate;
  }

  bookForm.find('.range-date').text(rangeDays);
  // bookBar.find('.range-date').text(rangeDays);

  var numRoom  = bookForm.find('[name="numofroom"]').val();
  var numAdult = bookForm.find('[name="numofadult"]').val();
  var numChild = bookForm.find('[name="numofchild"]').val();
  
  bookForm.find('.room-display').text(numRoom);
  bookForm.find('.adult-display').text(numAdult);
  bookForm.find('.child-display').text(numChild);

  // bookBar.find('.room-display').text(numRoom);
  // bookBar.find('.adult-display').text(numAdult);
  // bookBar.find('.child-display').text(numChild);

  var loadCI = moment(now).format('YYYY-MM-DD')
  var loadCO = moment(twoday).format('YYYY-MM-DD')
  
  bookForm.find('[name="checkin"]').val(loadCI);
  bookForm.find('[name="checkout"]').val(loadCO);
  
  // bookBar.find('[name="checkin"]').val(loadCI);
  // bookBar.find('[name="checkout"]').val(loadCO);

  var $widthCI  = bookForm.find('.t-checkin-number').innerWidth();
  var $widthCO  = bookForm.find('.t-checkout-number').innerWidth();
  var $posCI    = bookForm.find('.t-day-checkin');
  var $posCO    = bookForm.find('.t-day-checkout');

  $posCI.css({
    position: 'absolute',
    left: $widthCI + 5
  })
  
  $posCO.css({
    position: 'absolute',
    left: $widthCO + 5
  })

  // var $widthBarCI  = bookBar.find('.t-checkin-number').innerWidth();
  // var $widthBarCO  = bookBar.find('.t-checkout-number').innerWidth();
  // var $posBarCI    = bookBar.find('.t-day-checkin');
  // var $posBarCO    = bookBar.find('.t-day-checkout');

  // $posBarCI.css({
  //   position: 'absolute',
  //   left: $widthBarCI + 3
  // })
  
  // $posBarCO.css({
  //   position: 'absolute',
  //   left: $widthBarCO + 3
  // })
})

$('[data-toggle-panel-click]').on('click', function(event) {
  event.preventDefault();
  // $('.tl-booking-bar-wrapper').toggleClass('show');
  $('.tl-booking-panel-wrapper').toggleClass('show');
});

var datepickerBar = $('.datepicker-bar').tDatePicker({
  dateCheckIn: now,
  dateCheckOut: twoday,
  startDate: now,
  limitPrevMonth: 0,
  limitNextMonth: 60,
  limitDateRanges: 1825,
  showFullDateRanges: false,
  // fnDataEvent: holidays,
  // mergeDataEvent: true,
  numCalendar: 2,
  // titleCheckIn: 'Check In',
  // titleCheckOut: 'Check Out',
  titleToday: titletoday,
  titleDateRange: titledate,
  titleDateRanges: titledates,
  titleDays: titledays,
  titleMonths: titlemonths,
  titleMonthsLimitShow: 3,
  // replaceTitleMonths: '',
  showDateTheme: 'dd-mm-yy',
  iconArrowTop: true,
  iconDate: '<i class="fal fa-calendar-alt d-none" aria-hidden="true"></i>',
  arrowPrev: '<i class="fal fa-chevron-left" aria-hidden="true"></i>',
  arrowNext: '<i class="fal fa-chevron-right" aria-hidden="true"></i>',
  toDayShowTitle: true,
  dateRangesShowTitle: true,
  dateRangesHover: true,
  toDayHighlighted: true,
  nextDayHighlighted: false,
  daysOfWeekHighlighted: ['0','6'],
  // dateDisabled: disabledate,
}).on('afterCheckOut',function(e, dataDate){
  
  var valCI = new Date(dataDate[0]);
  var valCO = new Date(dataDate[1]);
  
  /* start custom new version **/
  var timeStamp   = (valCO - valCI) / 86400;
  var rangeDate   = (timeStamp / 1000);
  
  if(rangeDate > 1) {
    var rangeDays = rangeDate+' '+titledates;
  }
  if(rangeDate == 1) {
    var rangeDays = rangeDate+' '+titledate;
  }
  
  $('#booking_form').find('.range-date').text(rangeDays);

  var CIday = moment(valCI).format('ddd');
  var COday = moment(valCO).format('ddd');
  var CInum = moment(valCI).format('DD');
  var COnum = moment(valCO).format('DD');

  $('#booking_form').find('.t-checkin-number').text(CInum);
  $('#booking_form').find('.t-checkout-number').text(COnum);
  $('#booking_form').find('.t-day-checkin').text(CIday);
  $('#booking_form').find('.t-day-checkout').text(COday);

  /* end custom new version **/

  var $widthCI  = $('#booking_form').find('.t-checkin-number').innerWidth();
  var $widthCO  = $('#booking_form').find('.t-checkout-number').innerWidth();
  var $posCI    = $('#booking_form').find('.t-day-checkin');
  var $posCO    = $('#booking_form').find('.t-day-checkout');

  $posCI.css({
    position: 'absolute',
    left: $widthCI + 3
  })
  
  $posCO.css({
    position: 'absolute',
    left: $widthCO + 3
  })

  var valueCI = moment(valCI).format('YYYY-MM-DD');
  var valueCO = moment(valCO).format('YYYY-MM-DD');
  $('#booking_form').find('[name="checkin"]').val(valueCI);
  $('#booking_form').find('[name="checkout"]').val(valueCO);
})
datepickerBar.tDatePicker('update', [now,twoday]);

var datepickerPanel = $('.datepicker-panel').tDatePicker({
  dateCheckIn: now,
  dateCheckOut: twoday,
  startDate: now,
  limitPrevMonth: 0,
  limitNextMonth: 60,
  limitDateRanges: 1825,
  fnDataEvent: holidays,
  mergeDataEvent: true,
  showFullDateRanges: false,
  numCalendar: 1,
  titleCheckIn: 'Check In',
  titleCheckOut: 'Check Out',
  titleDateRange: titledate,
  titleDateRanges: titledates,
  titleToday: titletoday,
  titleDays: titledays,
  titleMonths: titlemonths,
  titleMonthsLimitShow: 3,
  showDateTheme: 'dd-mm-yy',
  iconArrowTop: false,
  iconDate: '<i class="fal fa-calendar-alt d-none" aria-hidden="true"></i>',
  arrowPrev: '<i class="fal fa-long-arrow-left" aria-hidden="true"></i>',
  arrowNext: '<i class="fal fa-long-arrow-right" aria-hidden="true"></i>',
  toDayShowTitle: false,
  dateRangesShowTitle: false,
  toDayHighlighted: true,
  nextDayHighlighted: true,
  daysOfWeekHighlighted: ['0','6'],
}).on('afterCheckOut',function(e, dataDate){
  var valCI = new Date(dataDate[0]);
  var valCO = new Date(dataDate[1]);
  
  /** start custom new version */
  var timeStamp   = (valCO - valCI) / 86400;
  var rangeDate   = (timeStamp / 1000);
  
  if(rangeDate > 1) {
    var rangeDays = rangeDate+' '+titledates;
  }
  if(rangeDate == 1) {
    var rangeDays = rangeDate+' '+titledate;
  }
  
  $('#form_booking').find('.range-date').text(rangeDays);

  var CIday = moment(valCI).format('ddd');
  var COday = moment(valCO).format('ddd');
  var CInum = moment(valCI).format('DD');
  var COnum = moment(valCO).format('DD');
  
  $('#form_booking').find('.t-checkin-number').text(CInum);
  $('#form_booking').find('.t-checkout-number').text(COnum);
  $('#form_booking').find('.t-day-checkin').text(CIday);
  $('#form_booking').find('.t-day-checkout').text(COday);
  /** end custom new version */

  var $widthCI  = $('#form_booking').find('.t-checkin-number').innerWidth();
  var $widthCO  = $('#form_booking').find('.t-checkout-number').innerWidth();
  var $posCI    = $('#form_booking').find('.t-day-checkin');
  var $posCO    = $('#form_booking').find('.t-day-checkout');

  $posCI.css({
    position: 'absolute',
    left: $widthCI + 5
  })
  
  $posCO.css({
    position: 'absolute',
    left: $widthCO + 5
  })

  var valueCI = moment(valCI).format('YYYY-MM-DD');
  var valueCO = moment(valCO).format('YYYY-MM-DD');
  $('#form_booking').find('[name="checkin"]').val(valueCI);
  $('#form_booking').find('[name="checkout"]').val(valueCO);
})
datepickerPanel.tDatePicker('update', [now,twoday]);

//
// Booking Panel
//
var maxAdult = bookForm.find('[name="maxadults"]').val();
var maxRooms = bookForm.find('[name="maxrooms"]').val();
var maxChild = bookForm.find('[name="maxchild"]').val();

$(document).on('click', function(e) {
  var $target = $(e.target);
  if (
    !$target.closest('.control-datepicker').length &&
    !$target.closest('.tl-booking-bar-wrapper').length &&
    !$target.closest('.tl-booking-panel-wrapper').length &&
    !$target.is('[data-toggle-panel-click]') &&
    !$target.is('.ui-datepicker-prev') &&
    !$target.is('.ui-datepicker-next')
  ) {
    $('.tl-booking-bar-wrapper').removeClass('show');
    $('.tl-booking-panel-wrapper').removeClass('show');
  }
});

var $room       = $('#room_display');
var $roomUp     = $room.find('.value-up');
var $roomDown   = $room.find('.value-down');
var $roomValue  = $room.find('.value');
var $roomField  = $room.find('[name="numofroom"]');

$roomUp.on('click', roomIncreasement);
$roomDown.on('click', roomDecreasement);

var $adult      = $('#adult_display');
var $adultUp    = $adult.find('.value-up');
var $adultDown  = $adult.find('.value-down');
var $adultValue = $adult.find('.value');
var $adultField = $adult.find('[name="numofadult"]');

$adultUp.on('click', adultIncreasement);
$adultDown.on('click', adultDecreasement);

var $child      = $('#child_display');
var $childUp    = $child.find('.value-up');
var $childDown  = $child.find('.value-down');
var $childValue = $child.find('.value');
var $childField = $child.find('[name="numofchild"]');

$childUp.on('click', childIncreasement);
$childDown.on('click', childDecreasement);

function updateValue(field, value) {
  $(field).val(value);
}

function setRoomValue(room) {
  updateValue($roomField, room);
  $roomValue.text(room);
  $('.room-display').text(room);
  checkStateRoomControl(room);
}

function setadultValue(adult) {
  updateValue($adultField, adult);
  $adultValue.text(adult);
  $('.adult-display').text(adult);
  checkStateadultControl(adult);
}

function setchildValue(child) {
  updateValue($childField, child);
  $childValue.text(child);
  $('.child-display').text(child);
  checkStatechildControl(child);
}

function roomIncreasement() {
  var value = parseInt($roomValue.text());
  if (value >= 1 && value < maxRooms) {
    var newValue = ++value;
    setRoomValue(newValue);
  }
}

function roomDecreasement() {
  var value = parseInt($roomValue.text());
  if (value > 1 && value <= maxRooms) {
    var newValue = --value;
    setRoomValue(newValue);
  }
}

function adultIncreasement() {
  var value = parseInt($adultValue.text());
  if (value >= 1 && value < maxAdult) {
    var newValue = ++value;
    setadultValue(newValue);
  }
}

function adultDecreasement() {
  var value = parseInt($adultValue.text());
  if (value > 1 && value <= maxAdult) {
    var newValue = --value;
    setadultValue(newValue);
  }
}

function childIncreasement() {
  var value = parseInt($childValue.text());
  if (value >= 0 && value < maxChild) {
    var newValue = ++value;
    setchildValue(newValue);
  }
}

function childDecreasement() {
  var value = parseInt($childValue.text());
  if (value > 0 && value <= maxChild) {
    var newValue = --value;
    setchildValue(newValue);
  }
}

function checkStateRoomControl(value) {
  if (value <= 1) {
    $roomDown.addClass('disabled');
  } else {
    $roomDown.removeClass('disabled');
  }
  if (value >= maxRooms) {
    $roomUp.addClass('disabled');
  } else {
    $roomUp.removeClass('disabled');
  }
}

function checkStateadultControl(value) {
  if (value <= 1) {
    $adultDown.addClass('disabled');
  } else {
    $adultDown.removeClass('disabled');
  }
  if (value >= maxAdult) {
    $adultUp.addClass('disabled');
  } else {
    $adultUp.removeClass('disabled');
  }
}

function checkStatechildControl(value) {
  if (value <= 0) {
    $childDown.addClass('disabled');
  } else {
    $childDown.removeClass('disabled');
  }
  if (value >= maxChild) {
    $childUp.addClass('disabled');
  } else {
    $childUp.removeClass('disabled');
  }
}
/** end booking panel */

//
// Booking Check
//
var propertyID  = bookForm.find('[name="propertyId"]').val();
var onlineID    = bookForm.find('[name="onlineId"]').val();
var accessCode  = bookForm.find('[name="accesscode"]').val();
var numberRoom  = bookForm.find('[name="numofroom"]').val();
var numberAdult = bookForm.find('[name="numofadult"]').val();
var numberChild = bookForm.find('[name="numofchild"]').val();

if(accessCode == '' || accessCode == undefined){
  accessCode = null
}

var options = {
  baseURL: 'https://reservation.travelanium.net/propertyibe2/',
  params: {
    propertyId: propertyID,
    onlineId: onlineID,
    checkin: now, // default is dynamic (today)
    checkout: twoday, // default is dynamic (next form today)
    numofroom: numberRoom,
    numofadult: numberAdult,
    numofchild: numberChild,
    accesscode: accessCode,
    lang: langPage,
    // currency: 'THB',
    // checkinauto: null,
    // numofnight: null,
    // pid: null,
    // pgroup: null,
  }
}

// Create instance with options
var bookingForm = new TLBooking('#form_booking', options);
// var bookingBar  = new TLBooking('#booking_form', options)

// Init the form
// bookingBar.form();
// AddGlobalFn('BookingBar', bookingBar);
bookingForm.form();
AddGlobalFn('BookingForm', bookingForm);
// console.log( OM.BookingForm );

// //
// // Member Panel
// //
// var $memberPanel = $('#member_panel');
// var format = 'hh:mm:ss';
// var time = moment.tz('Asia/Bangkok'),
//     beforeTimeMorning   = moment('05:00:00', format),
//     afterTimeMorning    = moment('11:59:59', format),
//     beforeTimeAfternoon = moment('12:00:00', format),
//     afterTimeAfternoon  = moment('17:59:59', format),
//     beforeTimeEvening   = moment('18:00:00', format),
//     afterTimeEvening    = moment('20:59:59', format),
//     beforeTimeNight     = moment('21:00:00', format),
//     afterTimeNight      = moment('04:59:59', format);

// if( time.isBetween( beforeTimeMorning, afterTimeMorning ) ) {
//   $memberPanel.find('.greeting-text').text('Good morning,');
// }

// if( time.isBetween( beforeTimeAfternoon, afterTimeAfternoon ) ) {
//   $memberPanel.find('.greeting-text').text('Good afternoon,');
// }

// if( time.isBetween( beforeTimeEvening, afterTimeEvening ) ) {
//   $memberPanel.find('.greeting-text').text('Good evening,');
// }

// if( time.isBetween( beforeTimeNight, afterTimeNight ) ) {
//   $memberPanel.find('.greeting-text').text('Good night,');
// }

// //
// // Check member
// //
// var getMember  = memberChecker();
// var codeMember = 'member'; 

// if (!getMember) {
//   // You're guest
//   $memberPanel.addClass('is-guest');
// } else {
//   // You're Member
//   createMemberUI(codeMember);
// }

// $.validate({
//   form: '#form_member',
//   modules: 'html5',
//   onSuccess: function($form) {
//     var email = $form.find('[name=email]').val();

//     memberCreateCookies({
//       code: codeMember,
//       expire: 7,
//       user: {
//         email: email,
//       }
//     });

//     var memberCode  = memberChecker().code;
//     window.open( 'https://reservation.travelanium.net/propertyibe2?propertyId='+propertyID+'&onlineId='+onlineID+'&accesscode='+memberCode, '_blank' );

//     createMemberUI( memberCode );
//     memberSendData({
//       formAPI: '3db559eeac12000261d32e19d9f901ac',
//       customer: {
//         email: email,
//       }
//     });

//     // $memberPanel.find('.user-member').text(email);

//     return false;
//   }
// });

// /**
//  * Create Member User Interface
//  * @param {string} code
//  */
// function createMemberUI(code) {
//   memberAppendCode(code);
//   $memberPanel.removeClass('is-guest').addClass('is-member');
//   if ('undefined' !== typeof OM.BookingForm) {
//     OM.BookingForm.setParam('accesscode', code);
//   } else {
//     console.log('OM.BookingForm not found')
//   }
// }

//
// Mouse Hover Accommodation
//
// var $panel  = $('.om-mega-menu-panel'); 
// var $megamenu = $('.om-mega-menu');
// var $meganotmenu = $('.om-mega-not-menu');
// $megamenu.on('mouseenter', function(e){
//   $panel.addClass('show');
// });
// $panel.on('mouseleave', function(e){
//   $panel.removeClass('show');
// });
// $meganotmenu.on('mouseenter', function(e){
//   $panel.removeClass('show');
// });
// $meganotmenu.on('mouseleave', function(e){
//   $panel.removeClass('show');
// });

//
// Click Menu Dropdown
//
$('.menu-item-dropdown').on('click', function(){
  $(this).toggleClass('show')
})

//
// Detect Browser
//
$(window).on('load', function() {
  var result = detect();
  // console.log(result.name);
  if (result) {
    switch (result.name) {
      case 'chrome':
        // console.log(`found ${result.type} bot`);
        $('body').addClass('chrome-rendered')
        break;
        
      case 'safari':
        // console.log(`found ${result.type} device bot`);
        $('body').addClass('safari-rendered')
        break;

      case 'firefox':
        // console.log(`found ${result.type} device bot`);
        $('body').addClass('firefox-rendered')
        break;

      case 'edge-chromium':
        // console.log(`found ${result.type} device bot`);
        $('body').addClass('edge-rendered')
        break;

      case 'ie':
        // console.log(`found ${result.type} device bot`);
        $('body').addClass('ie-rendered')
        break;

    }
  }
});

//
// Menu Layout
//
// $(window).on('load resize', function(){
//   // var winW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
//   // if (winW >= 576) {
//   //   var $menu = $('.om-side-panel__inner ul.menu');
//   //   var menus = $menu.isotope({
//   //     itemSelector: '.menu-item-isotope',
//   //   })
//   // }

//   var $Isotopemenu  = $('.menu-item-isotope');
//   var $menulength   = $Isotopemenu.length;
//   var i;

//   for (i = 0; i <= $menulength; i++) {
//     if (i < 9) {
//       var $Isotopepanel = $('<span class="num-menu">0'+ (i + 1) +'</span>');
//       $Isotopepanel.appendTo($Isotopemenu[i]);
//     } else {
//       var $Isotopepanel = $('<span class="num-menu">'+ (i + 1) +'</span>');
//       $Isotopepanel.appendTo($Isotopemenu[i]);
//     }
//   }
// });

//
// Subscribe Form
//
// $.validate({
//   form: '#subscribe_form',
//   modules: 'html5, security',
//   onSuccess: function( $form ) {
//     var form = $form.get(0);
//     var fromURL = form.baseURI;
//     var formAction = form.action;
//     var formData = $form.serializeArray();

//     formData.push({
//       name: 'base',
//       value: fromURL,
//     });

//     var result = $form.find('.result');
//     var $name  = $form.find('#c_name').val();
//     var $email = $form.find('#c_email').val();

//     var txtSuccess = 'Send Successful';
//     var txtFailed  = 'Send Failed!!';

//     var sendform = tlForm({
//       key: '51f8520dac12000547a5558b377e3c99',
//       data: {
//         name: $name,
//         email: $email,
//       },
//     });

//     if (!sendform) {
//       $form.addClass('success')
//       .removeClass('failed')
//       .find(':focus').blur();
//       result.hide();
//       result.html(txtSuccess).slideDown();
//       form.reset();
//     } else {
//       $form.addClass('failed')
//         .removeClass('success');
//       result.hide();
//       result.html(txtFailed).slideDown();            
//     }

//     return false;
//   },
//   onError: function( $form ) {
//     var form = $form.get(0);
//     var result = $form.find('.result');
//     result.hide();
//   },
// });

// $.validate({
//   form: '#form_subscribe',
//   modules: 'html5, security',
//   onSuccess: function( $form ) {
//     var form = $form.get(0);
//     var fromURL = form.baseURI;
//     var formAction = form.action;
//     var formData = $form.serializeArray();

//     formData.push({
//       name: 'base',
//       value: fromURL,
//     });

//     var result = $form.find('.result');
//     var $name  = $form.find('#s_name').val();
//     var $email = $form.find('#s_email').val();

//     var txtSuccess = 'Send Successful';
//     var txtFailed  = 'Send Failed!!';

//     var sendform = tlForm({
//       key: '51f8520dac12000547a5558b377e3c99',
//       data: {
//         name: $name,
//         email: $email,
//       },
//     });

//     if (!sendform) {
//       $form.addClass('success')
//       .removeClass('failed')
//       .find(':focus').blur();
//       result.hide();
//       result.html(txtSuccess).slideDown();
//       form.reset();
//     } else {
//       $form.addClass('failed')
//         .removeClass('success');
//       result.hide();
//       result.html(txtFailed).slideDown();            
//     }

//     return false;
//   },
//   onError: function( $form ) {
//     var form = $form.get(0);
//     var result = $form.find('.result');
//     result.hide();
//   },
// });